import { heliBoard, heliLeave, heliPick, heliDepart } from '../services/worldSocket';
import { useHeliTour, FLIGHTS, COUNTDOWN_MS, flightById } from './heliTour';

// WHAT THE HELIPORT'S BUTTONS DO (HeliPanel), server first: the API's heli
// tours keep the seats and stamp the take-off (API sockets/heliTourStore), so
// friends at the same pad fly the same flight. When no server answers (an API
// without heli tours — live-safe until it deploys, or no connection), the
// flight is this browser's alone: you board, pick and lift off on your own
// clock, and nobody else sees it.
const ME = 'me';

function setPad(id, patch) {
  useHeliTour.setState((s) => ({ pads: { ...s.pads, [id]: { ...(s.pads[id] || { state: 'idle', seats: [] }), ...patch } } }));
}

export async function boardPad(pad) {
  const r = await heliBoard(pad);
  if (r?.ok) { useHeliTour.setState({ mine: { pad } }); return r; }
  if (!r?.offline) return r;
  // Nobody to ask: your own flight.
  useHeliTour.setState({ offline: true, myId: ME, mine: { pad } });
  setPad(pad, { state: 'boarding', flight: FLIGHTS[0].id, host: ME, seats: [{ id: ME, handle: 'You' }], departAt: null, endsAt: null });
  return { ok: true, offline: true };
}

export async function leavePad() {
  const st = useHeliTour.getState();
  const pad = st.mine?.pad;
  if (!pad) return;
  const p = st.pads[pad];
  if (p?.state === 'flying') return;   // no getting out in the air
  useHeliTour.setState({ mine: null });
  if (st.offline) { setPad(pad, { state: 'idle', seats: [], host: null }); return; }
  await heliLeave(pad);
}

export async function pickFlight(flight) {
  const st = useHeliTour.getState();
  const pad = st.mine?.pad;
  if (!pad || !flightById(flight)) return;
  if (st.offline) { setPad(pad, { flight }); return; }
  await heliPick(pad, flight);
}

export async function takeOff() {
  const st = useHeliTour.getState();
  const pad = st.mine?.pad;
  const p = pad ? st.pads[pad] : null;
  if (!p || p.state !== 'boarding') return;
  if (st.offline) {
    const f = flightById(p.flight) || FLIGHTS[0];
    const departAt = Date.now() + COUNTDOWN_MS;
    setPad(pad, { state: 'flying', flight: f.id, departAt, endsAt: departAt + f.seconds * 1000 + 3000 });
    return;
  }
  await heliDepart(pad, p.flight || FLIGHTS[0].id);
}

/**
 * A flight that has come home: the pad is free again and you are on the ground.
 * The server says so itself (its sweep); this is the local flight's ending, and
 * the safety net if a server message is missed.
 */
export function landIfDone(now = Date.now()) {
  const st = useHeliTour.getState();
  for (const [id, p] of Object.entries(st.pads)) {
    if (p?.state !== 'flying' || !p.endsAt) continue;
    const grace = st.offline ? 0 : 6000;
    if (now > p.endsAt + grace) {
      setPad(id, { state: 'idle', seats: [], host: null, departAt: null, endsAt: null });
      if (st.mine?.pad === id) useHeliTour.setState({ mine: null });
    }
  }
}
